import Intro from './Intro';
import FeaturedArticles from './FeaturedArticles';
import ImagesWithCircle from './ImagesWithCircle';
import CircleGroup from './CircleGroup';
import Outcomes from '../Outcomes';

export default {
  Intro,
  FeaturedArticles,
  ImagesWithCircle,
  CircleGroup,
  Outcomes
};
